import React, { useEffect } from 'react';
import {
  CurrencySelector,
  useCurrencyConfigContext,
} from '@amzn/aaccurrency-visualisation-ui';
import { formatLocale } from 'src/providers/PantherLocalizationProvider/mbm';
import { CurrencySwitcherPublisher } from 'src/commons/utils/metrics';
import { currencyofViewSwitch } from 'src/commons/utils/helpers';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

const CurrencyVisualisation: React.VFC = () => {
  const { selectedCurrency, currencyList } = useCurrencyConfigContext();
  const { config: internalChromeConfig } = useInternalChromeConfigContext();

  const onApplyChange = (newCurrency) => {
    if (newCurrency?.code) {
      currencyofViewSwitch(selectedCurrency.code, newCurrency.code);
    }
  };

  if (
    selectedCurrency === undefined ||
    (Array.isArray(currencyList) && currencyList.length === 0)
  ) {
    return null;
  }

  useEffect(() => {
    CurrencySwitcherPublisher.publishCounterMonitor('currecyOfViewRendered', 1);
  }, []);

  return (
    <CurrencySelector
      id="aac-chrome-currency-switcher"
      locale={formatLocale(internalChromeConfig.locale)}
      onApplyChange={onApplyChange}
    />
  );
};

export default CurrencyVisualisation;
